<div class="article col-lg-12 mt-5 mb-3 d-flex flex-column flex-lg-row justify-content-lg-between">
  <section class="col-lg-1 d-flex flex-column p-0 back-button">
    <app-back-button (click)="trackEvent('article-back-article')"></app-back-button>
  </section>

  <!--- Skeleton for loading state ---->
  <app-skeleton *ngIf="!article">
    <section class="col d-flex flex-column">
      <div class="article-container d-flex flex-column-reverse">
        <article>
          <div class="play-component d-none d-lg-block">
            <span class="player">
              <i class="fa fa-pause" aria-hidden="true"></i>
            </span>
            <span class="player">
              <i class="fa fa-spinner fa-pulse fa-1x" aria-hidden="true"></i>
            </span>
            <span class="player">
              <app-etx-icons name="play_white"></app-etx-icons>
            </span>
          </div>
          <div class="d-lg-flex title mb-1 mb-sm-3 skeleton_light">
            <h2 class="skeleton_dark">Lorem ipsum dolor sit amet, consectetur adipiscing elit</h2>
          </div>

          <div class="img d-flex flex-column">
            <div
              class="actions d-flex flex-row flex-lg-column align-items-center justify-content-between justify-content-lg-around"
            >
              <div class="play-component d-lg-none">
                <span class="player skeleton_dark">
                  <app-etx-icons name="play_white"></app-etx-icons>
                </span>
              </div>
              <span
                title="{{ 'ARTICLE_COPY_ARTICLE' | translate }}"
                data-toggle="tooltip"
                data-placement="right"
                class="skeleton_dark"
              >
                <app-etx-icons
                  name="copy"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="{{ 'ARTICLE_COPY_ARTICLE' | translate }}"
                ></app-etx-icons>
              </span>

              <div>
                <span title="{{ 'ARTICLE_DOWNLOAD_IMAGE' | translate }}" class="skeleton_dark">
                  <app-etx-icons
                    name="download"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="{{ 'ARTICLE_DOWNLOAD_IMAGE' | translate }}"
                  ></app-etx-icons>
                </span>
              </div>
              <span class="skeleton_dark" title="{{ 'ARTICLE_EDIT_ARTICLE' | translate }}">
                <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: #160a36 !important;
                      }
                    </style>
                  </defs>
                  <path
                    class="cls-1"
                    d="M17.69 11.25v6.44H6.34V6.34h6.44a.85.85 0 00.85-.85.85.85 0 00-.85-.85H6.34a1.7 1.7 0 00-1.7 1.7v11.35a1.7 1.7 0 001.7 1.7h11.35a1.7 1.7 0 001.7-1.7v-6.44a.85.85 0 00-.85-.85.85.85 0 00-.85.85zM19.91 6a1.35 1.35 0 000-1.9 1.33 1.33 0 00-1.9 0l-.74.74 1.9 1.9z"
                  ></path>
                  <path
                    class="cls-1"
                    d="M12.29 12l1.94-.38a.24.24 0 00.13-.07l4.24-4.22-1.9-1.9-4.25 4.24a.31.31 0 00-.06.13L12 11.74a.24.24 0 00.29.26z"
                  ></path>
                </svg>
              </span>
            </div>
            <div class="row mb-3">
              <div class="col skeleton_light">
                <div class="publish-info skeleton_dark">
                  Published on
                  <time>Jul 6 2021 17:51</time> | by ETX Daily UP
                </div>
              </div>
            </div>
            <div class="position-relative">
              <div
                class="img-container d-flex flex-column-reverse flex-lg-row rounded position-relative mw-100 rounded-img skeleton_dark"
              >
                <!--                <img width="900" height="450" class="mw-100 rounded-img skeleton_dark" alt="image title" />-->
                <span style="width: 900px; height: 450px" class=""></span>
              </div>
              <div class="d-flex justify-content-end">
                <span class="photo-credit text-end"
                  >{{ 'PHOTOGRAPHY' | translate }} {{ article?.images[0].credits }}©</span
                >
                <span class="photo-credit text-end"> {{ article?.images[0].special_uses }}</span>
              </div>
            </div>
          </div>

          <div class="d-flex flex-column description mt-2 mb-4">
            <p class="header-description text-justify skeleton_dark">
              Le jour tant attendu est arrivé. Cannes, sa croisette et ses hôtels de luxe ont accueilli stars françaises
              et internationales pour une 74e édition visiblement placée sous le signe d'un glamour retrouvé. Après
              avoir fait les frais de la pandémie en 2020, le Festival de Cannes renoue avec ce chic à la française que
              le monde nous envie tant, mais également avec une certaine extravagance, qu'on lit dans l'omniprésence des
              paillettes, des sequins, et des couleurs vibrantes, et qui avait tant manqué depuis le début de la crise
              sanitaire.
            </p>
            <p class="header-body text-justify skeleton_dark">
              Impossible d'admirer le tapis rouge de la cérémonie d'ouverture du Festival de Cannes sans retenir non pas
              une larme mais un sourire. Joie de voir des robes toutes plus glamour les unes que les autres défiler sur
              le tapis rouge du Palais des Festivals. Joie de voir s'afficher le bonheur des retrouvailles sur des
              visages radieux. Joie de retrouver l'effervescence d'un événement hors norme. Joie de voir que la vie
              reprend, tout simplement. Et il faut dire que les personnalités présentes ont mis les petits plats dans
              les grands pour cette cérémonie d'ouverture. Certains diront peut-être que ce n'est pas approprié au
              regard de la période, mais c'est en réalité ce dont chacun a besoin : glamour, extravagance, folie. C'est
              d'ailleurs exactement ce que le commun des mortels - nous tous, en somme - recherchera tout au long de
              l'été. Ce besoin de (re)mettre des paillettes dans nos vies. C'est d'ailleurs ce qu'ont fait Carla Bruni,
              Candice Swanepoel, et Mélanie Laurent, qui sont apparues dans de somptueux ensembles entièrement
              recouverts de détails scintillants, summum du glamour. Farhana Bodi a de son côté illuminé le tapis rouge
              dans une spectaculaire robe jaune dotée d'une interminable traîne. Marion Cotillard et Lou Doillon ont
              quant à elles opté pour l'iridescence, l'une version argentée, l'autre couleur or, quand Spike Lee s'est
              distingué de ses confrères en s'exhibant dans un costume rose vibrant, lunettes assorties, et sneakers aux
              pieds. Glamour, fantaisie, et confort peuvent bel et bien cohabiter. Et que dire de l'actrice Iris Berben
              qui a fait le choix osé de la robe à message, sur laquelle on pouvait lire "Plus forts ensemble", qui a
              également fait l'unanimité. Et quand la sobriété était de mise, elle n'en était pas moins glamour. En
              témoignent les tenues de Jessica Chastain et de Leïla Bekhti, la première vêtue d'une robe noire
              arachnéenne, la seconde d'un tailleur blanc au vertigineux décolleté, qui ont également brillé sur le
              tapis rouge cannois. Un véritable bonheur de retrouver ce beau monde, plus pomponné que jamais, dont le
              défilé signe, on l'espère définitivement, le retour d'un glamour qui nous avait manqué.
            </p>
            <span class="credits align-self-end m-2">{{ article?.signature }}</span>
          </div>
        </article>
      </div>
    </section>
  </app-skeleton>

  <!--- When article has loaded -->
  <section *ngIf="article" class="col-lg-7 d-flex flex-column m-md-1" style="padding-right: 15px; padding-left: 15px">
    <div class="article-container d-flex flex-column-reverse">
      <article #articleRef>
        <div class="play-component d-none d-lg-block">
          <span *ngIf="!(isLoadingAudio$ | async) && (isPlaying$ | async)" (click)="pauseAudio()" class="player">
            <i class="fa fa-pause" aria-hidden="true"></i>
          </span>
          <span *ngIf="isLoadingAudio$ | async" class="player">
            <i class="fa fa-spinner fa-pulse fa-1x" aria-hidden="true"></i>
          </span>
          <span
            *ngIf="!(isLoadingAudio$ | async) && !(isPlaying$ | async)"
            (click)="generateAndPlayAudio()"
            class="player"
          >
            <app-etx-icons name="play_white"></app-etx-icons>
          </span>
        </div>
        <div class="d-lg-flex title mb-1">
          <h2>{{ article?.title }}</h2>
        </div>

        <div class="img d-flex flex-column" *ngIf="article?.images && article?.images?.length">
          <div
            class="actions d-flex flex-row flex-lg-column align-items-center justify-content-between justify-content-lg-around"
          >
            <div class="play-component">
              <span *ngIf="!(isLoadingAudio$ | async) && (isPlaying$ | async)" (click)="pauseAudio()" class="player">
                <i class="fa fa-pause" aria-hidden="true"></i>
              </span>
              <span *ngIf="isLoadingAudio$ | async" class="player">
                <i class="fa fa-spinner fa-pulse fa-1x" aria-hidden="true"></i>
              </span>
              <span
                *ngIf="!(isLoadingAudio$ | async) && !(isPlaying$ | async)"
                (click)="generateAndPlayAudio()"
                class="player"
              >
                <app-etx-icons name="play_white"></app-etx-icons>
              </span>
            </div>
            <span
              (click)="copyToClipboard(article)"
              title="{{ 'ARTICLE_COPY_ARTICLE' | translate }}"
              data-toggle="tooltip"
              data-placement="right"
            >
              <app-etx-icons
                name="copy"
                data-toggle="tooltip"
                data-placement="right"
                title="{{ 'ARTICLE_COPY_ARTICLE' | translate }}"
              ></app-etx-icons>
              <ngb-alert
                class="copied-msg"
                #selfClosingAlert
                *ngIf="successMessage === 'ARTICLE_COPIED'"
                [dismissible]="false"
                type="success"
                (closed)="successMessage = ''"
                >{{ 'COPIED' | translate }}
              </ngb-alert>
            </span>

            <div *ngIf="article?.images?.length === 1">
              <span title="{{ 'ARTICLE_DOWNLOAD_IMAGE' | translate }}" (click)="downloadArticleImage(article)">
                <app-etx-icons
                  *ngIf="!loadingDownloadImage"
                  name="download"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="{{ 'ARTICLE_DOWNLOAD_IMAGE' | translate }}"
                ></app-etx-icons>
                <i
                  *ngIf="loadingDownloadImage"
                  class="fa fa-spinner fa-pulse fa-2x"
                  style="color: #342265"
                  aria-hidden="true"
                ></i>
              </span>
            </div>
            <div *ngIf="article?.images?.length > 1" class="dropdown show">
              <span
                title="{{ 'ARTICLE_DOWNLOAD_IMAGE' | translate }}"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <app-etx-icons
                  *ngIf="!loadingDownloadImage"
                  name="download"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="{{ 'ARTICLE_DOWNLOAD_IMAGE' | translate }}"
                ></app-etx-icons>
                <i
                  *ngIf="loadingDownloadImage"
                  class="fa fa-spinner fa-pulse fa-2x"
                  style="color: #342265"
                  aria-hidden="true"
                ></i>
              </span>

              <div *ngIf="article?.images?.length > 1" class="dropdown-menu shadow" aria-labelledby="dropdownMenuLink">
                <a class="dropdown-item" href="#" (click)="onClickDownloadAllImages($event)">{{
                  'DOWNLOAD_ALL_IMAGES' | translate: { imagesNumber: article?.images?.length }
                }}</a>
                <a class="dropdown-item" href="#" (click)="downloadArticleImage(article, $event)">{{
                  'DOWNLOAD_CURRENT_IMAGE' | translate
                }}</a>
              </div>
            </div>
            <!--<span (click)="editArticle()">
              <app-etx-icons
                name="edit"
                data-toggle="tooltip"
                data-placement="right"
                title="{{ 'ARTICLE_EDIT_ARTICLE' | translate }}"
              ></app-etx-icons>
            </span>-->
            <span (click)="editArticle()" class="" title="{{ 'ARTICLE_EDIT_ARTICLE' | translate }}">
              <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <defs>
                  <style>
                    .cls-1 {
                      fill: #160a36 !important;
                    }
                  </style>
                </defs>
                <path
                  class="cls-1"
                  d="M17.69 11.25v6.44H6.34V6.34h6.44a.85.85 0 00.85-.85.85.85 0 00-.85-.85H6.34a1.7 1.7 0 00-1.7 1.7v11.35a1.7 1.7 0 001.7 1.7h11.35a1.7 1.7 0 001.7-1.7v-6.44a.85.85 0 00-.85-.85.85.85 0 00-.85.85zM19.91 6a1.35 1.35 0 000-1.9 1.33 1.33 0 00-1.9 0l-.74.74 1.9 1.9z"
                ></path>
                <path
                  class="cls-1"
                  d="M12.29 12l1.94-.38a.24.24 0 00.13-.07l4.24-4.22-1.9-1.9-4.25 4.24a.31.31 0 00-.06.13L12 11.74a.24.24 0 00.29.26z"
                ></path>
              </svg>
            </span>
          </div>
          <div class="row mb-3">
            <div class="col">
              <div class="publish-info">
                {{ 'ARTICLE_PUBLISHED_ON' | translate }}
                <time>{{ article?.publication_date | date: 'MMM d y H:mm' }}</time> | {{ 'ARTICLE_BY' | translate }}
                <span class=""
                  >{{ article?.platformName === 'ETX Studio' ? 'ETX Daily Up' : article?.platformName }}
                  <app-main-category-btn
                    (searchString$)="search($event)"
                    mainCategory="{{ article?.mainCategory }}"
                  ></app-main-category-btn
                ></span>
              </div>
            </div>
          </div>

          <div class="article-video-embed" *ngIf="article?.video_url && !article?.images?.length">
            <app-video-embed
              [customDownloadLink]="customDownloadLink"
              [videoTitle]="article?.title"
              [videoSources]="article?.video_url"
            ></app-video-embed>
          </div>

          <div
            *ngIf="article?.images?.length > 1 || (article?.video_url && article?.images?.length)"
            class="position-relative d-flex flex-column"
          >
            <button *ngIf="article?.images?.length" class="image-counter">
              <span class="image-counter-text">
                {{ article?.video_url ? article?.images?.length + 1 : article?.images?.length }}</span
              >
              <img class="count-img" src="../assets/images/pictos/multi-image-icon.png" />
            </button>
            <div class="navigation-wrapper">
              <div class="keen-slider keen-slider--vertical" #sliderRef>
                <div *ngIf="article?.video_url" class="keen-slider__slide number">
                  <div class="img-container d-flex flex-column-reverse flex-lg-row rounded position-relative">
                    <app-video-embed
                      [customDownloadLink]="customDownloadLink"
                      [videoTitle]="article?.title"
                      [videoSources]="article?.video_url"
                      style="width: 100%"
                    ></app-video-embed>
                  </div>
                </div>
                <div *ngFor="let image of article?.images; let i = index" class="keen-slider__slide number">
                  <div class="img-container d-flex flex-column-reverse flex-lg-row rounded position-relative">
                    <img
                      width="900"
                      height="450"
                      class="mw-100 rounded-img position-relative story-items-list d-flex flex-column"
                      alt="{{ image.title }}"
                      [src]="loaded[i] ? image.s_large : ''"
                      [srcset]="getImageSrcset(i)"
                    />
                    <span
                      class="article-img-legend cursor-pointer"
                      title="{{ 'ARTICLE_COPY_DESCRIPTION' | translate }}"
                      data-toggle="tooltip"
                      data-placement="right"
                      (click)="copyToClipboard(image.title, 'description', 'short')"
                    >
                      <ngb-alert
                        class="copied-description-msg"
                        #selfClosingAlert
                        *ngIf="successMessage === 'DESCRIPTION_COPIED'"
                        [dismissible]="false"
                        type="success"
                        (closed)="successMessage = ''"
                        >{{ 'COPIED' | translate }}
                      </ngb-alert>
                      {{ image.title }}
                      <span class="copy-clipboard-article-description">
                        <svg
                          id="Calque_1"
                          data-name="Calque 1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          style="font-size: 24px; height: 24px; width: 24px; opacity: 0.9"
                        >
                          <path
                            class="icon-copy-descrption-to-clipboard"
                            d="M18.48 9.2v9.94H8.54V9.2h9.94m0-1.7H8.54a1.7 1.7 0 00-1.7 1.7v9.94a1.7 1.7 0 001.7 1.7h9.94a1.7 1.7 0 001.7-1.7V9.2a1.7 1.7 0 00-1.7-1.7z"
                          ></path>
                          <path
                            class="icon-copy-descrption-to-clipboard"
                            d="M16.78 4.19H5.23a1.7 1.7 0 00-1.7 1.7v11.64h1.7V5.89h11.55z"
                          ></path>
                        </svg>
                        <!-- <app-etx-icons
                        name="copy"
                        data-toggle="tooltip"
                        data-placement="right"
                        title="{{ 'ARTICLE_COPY_DESCRIPTION' | translate }}"
                      ></app-etx-icons> -->
                      </span>
                    </span>
                  </div>
                  <div class="d-flex justify-content-end flex-wrap position-relative">
                    <ngb-alert
                      class="copied-copyright-msg"
                      #selfClosingAlert
                      *ngIf="successMessage === 'COPYRIGHT_COPIED'"
                      [dismissible]="false"
                      type="success"
                      (closed)="successMessage = ''"
                      >{{ 'COPIED' | translate }}
                    </ngb-alert>
                    <span
                      *ngIf="image.credits"
                      class="photo-credit text-end cursor-pointer"
                      (click)="
                        copyToClipboard(
                          image.credits + '©' + (image.special_uses ? ', ' + image.special_uses : ''),
                          'copyright',
                          'copyright'
                        )
                      "
                    >
                      {{ 'PHOTOGRAPHY' | translate }} {{ image.credits }}©
                      <span class="copy-clipboard-article-copyright">
                        <svg
                          id="Calque_1"
                          data-name="Calque 1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          style="font-size: 24px; height: 24px; width: 24px; opacity: 0.9"
                        >
                          <path
                            class="icon-copy-descrption-to-clipboard"
                            style="fill: black"
                            d="M18.48 9.2v9.94H8.54V9.2h9.94m0-1.7H8.54a1.7 1.7 0 00-1.7 1.7v9.94a1.7 1.7 0 001.7 1.7h9.94a1.7 1.7 0 001.7-1.7V9.2a1.7 1.7 0 00-1.7-1.7z"
                          ></path>
                          <path
                            class="icon-copy-descrption-to-clipboard"
                            style="fill: black"
                            d="M16.78 4.19H5.23a1.7 1.7 0 00-1.7 1.7v11.64h1.7V5.89h11.55z"
                          ></path>
                        </svg>
                      </span>
                    </span>
                    <span
                      *ngIf="image.special_uses"
                      class="photo-credit text-end cursor-pointer"
                      (click)="
                        copyToClipboard(
                          image.credits + '©' + (image.special_uses ? ', ' + image.special_uses : ''),
                          'copyright',
                          'copyright'
                        )
                      "
                    >
                      {{ image.special_uses }}</span
                    >
                  </div>
                </div>
              </div>
              <svg
                [ngClass]="'arrow arrow--left ' + (currentSlide === 0 ? 'arrow--disabled' : '')"
                (click)="slider.prev()"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
              </svg>
              <svg
                *ngIf="slider"
                [ngClass]="
                  'arrow arrow--right ' + (slider.details().size - 1 === currentSlide ? 'arrow--disabled' : '')
                "
                (click)="slider.next()"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
              </svg>
            </div>
          </div>

          <div *ngIf="!article?.video_url && article?.images?.length === 1" class="position-relative">
            <div class="img-container d-flex flex-column-reverse flex-lg-row rounded position-relative">
              <img
                width="900"
                height="450"
                class="mw-100 rounded-img"
                alt="{{ article?.images[0].title }}"
                [src]="article?.images[0].s_large"
                [srcset]="getImageSrcset(0)"
              />
              <span
                class="article-img-legend cursor-pointer"
                title="{{ 'ARTICLE_COPY_DESCRIPTION' | translate }}"
                data-toggle="tooltip"
                data-placement="right"
                (click)="copyToClipboard(article?.images[0].title, 'description', 'short')"
              >
                <ngb-alert
                  class="copied-description-msg"
                  #selfClosingAlert
                  *ngIf="successMessage === 'DESCRIPTION_COPIED'"
                  [dismissible]="false"
                  type="success"
                  (closed)="successMessage = ''"
                  >{{ 'COPIED' | translate }}
                </ngb-alert>
                {{ article?.images[0].title }}
                <span class="copy-clipboard-article-description">
                  <svg
                    id="Calque_1"
                    data-name="Calque 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    style="font-size: 24px; height: 24px; width: 24px; opacity: 0.6"
                  >
                    <path
                      class="icon-copy-descrption-to-clipboard"
                      d="M18.48 9.2v9.94H8.54V9.2h9.94m0-1.7H8.54a1.7 1.7 0 00-1.7 1.7v9.94a1.7 1.7 0 001.7 1.7h9.94a1.7 1.7 0 001.7-1.7V9.2a1.7 1.7 0 00-1.7-1.7z"
                    ></path>
                    <path
                      class="icon-copy-descrption-to-clipboard"
                      d="M16.78 4.19H5.23a1.7 1.7 0 00-1.7 1.7v11.64h1.7V5.89h11.55z"
                    ></path>
                  </svg>
                  <!-- <app-etx-icons
                      name="copy"
                      data-toggle="tooltip"
                      data-placement="right"
                      title="{{ 'ARTICLE_COPY_DESCRIPTION' | translate }}"
                    ></app-etx-icons> -->
                </span>
              </span>
            </div>
            <div class="d-flex justify-content-end position-relative">
              <ngb-alert
                class="copied-copyright-msg"
                #selfClosingAlert
                *ngIf="successMessage === 'COPYRIGHT_COPIED'"
                [dismissible]="false"
                type="success"
                (closed)="successMessage = ''"
                >{{ 'COPIED' | translate }}
              </ngb-alert>
              <span
                *ngIf="article?.images[0].credits"
                class="photo-credit text-end cursor-pointer"
                (click)="
                  copyToClipboard(
                    article?.images[0].credits +
                      '©' +
                      (article?.images[0].special_uses ? ', ' + article?.images[0].special_uses : ''),
                    'copyright',
                    'copyright'
                  )
                "
              >
                {{ 'PHOTOGRAPHY' | translate }} {{ article?.images[0].credits }}©
                <span class="copy-clipboard-article-copyright">
                  <svg
                    id="Calque_1"
                    data-name="Calque 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    style="font-size: 24px; height: 24px; width: 24px; opacity: 0.9"
                  >
                    <path
                      class="icon-copy-descrption-to-clipboard"
                      style="fill: black"
                      d="M18.48 9.2v9.94H8.54V9.2h9.94m0-1.7H8.54a1.7 1.7 0 00-1.7 1.7v9.94a1.7 1.7 0 001.7 1.7h9.94a1.7 1.7 0 001.7-1.7V9.2a1.7 1.7 0 00-1.7-1.7z"
                    ></path>
                    <path
                      class="icon-copy-descrption-to-clipboard"
                      style="fill: black"
                      d="M16.78 4.19H5.23a1.7 1.7 0 00-1.7 1.7v11.64h1.7V5.89h11.55z"
                    ></path>
                  </svg>
                </span>
              </span>
              <span
                *ngIf="article?.images[0].special_uses"
                class="photo-credit text-end cursor-pointer"
                (click)="
                  copyToClipboard(
                    article?.images[0].credits +
                      '©' +
                      (article?.images[0].special_uses ? ', ' + article?.images[0].special_uses : ''),
                    'copyright',
                    'copyright'
                  )
                "
              >
                {{ article?.images[0].special_uses }}</span
              >
            </div>
          </div>
        </div>

        <div class="d-flex flex-column description mt-2 mb-4">
          <!--          <iframe-->
          <!--            width="360"-->
          <!--            height="640"-->
          <!--            src="https://rio-dev.etx.studio/player?url=https://audio-assets-dev.etx.studio/a4029864-6d41-5637-a92a-d653f40bd900.mp4&lang=fr"-->
          <!--            title="ETX video player"-->
          <!--            frameborder="0"-->
          <!--            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"-->
          <!--            allowfullscreen-->
          <!--          ></iframe>-->
          <p class="header-description text-justify" [innerHtml]="article?.header"></p>
          <p
            *ngIf="article?.content"
            class="header-body text-justify"
            [innerHtml]="article?.content | safe: 'html'"
          ></p>
          <span class="credits align-self-end m-2">{{ article?.signature }}</span>
          <div class="bannerNotLoggedIn__container">
            <div
              *ngIf="!isLoggedIn && article"
              class="bannerNotLoggedIn"
              (click)="redirectToRegister()"
              style="cursor: pointer"
            >
              <svg
                class="bannerNotLoggedIn__icon_unlock"
                xmlns="http://www.w3.org/2000/svg"
                height="200%"
                width="70%"
                viewBox="0 0 50 50"
              >
                <path
                  d="M11 16.3h19.5v-4.8q0-2.7-1.9-4.6Q26.7 5 24 5q-2.7 0-4.6 1.9-1.9 1.9-1.9 4.6h-3q0-3.95 2.775-6.725Q20.05 2 24 2q3.95 0 6.725 2.775Q33.5 7.55 33.5 11.5v4.8H37q1.25 0 2.125.875T40 19.3V41q0 1.25-.875 2.125T37 44H11q-1.25 0-2.125-.875T8 41V19.3q0-1.25.875-2.125T11 16.3ZM11 41h26V19.3H11V41Zm13-7q1.6 0 2.725-1.1t1.125-2.65q0-1.5-1.125-2.725T24 26.3q-1.6 0-2.725 1.225T20.15 30.25q0 1.55 1.125 2.65Q22.4 34 24 34Zm-13 7V19.3 41Z"
                />
              </svg>

              <div class="bannerNotLoggedIn__header">
                <div class="bannerNotLoggedIn__title">{{ 'BANNER_ARTICLE_TITLE' | translate }}</div>
                <div class="bannerNotLoggedIn__subtitle">{{ 'BANNER_ARTICLE_SUBTITLE' | translate }}</div>
              </div>
              <div class="bannerNotLoggedIn__body">
                <div class="bannerNotLoggedIn__body_part">
                  <div class="bannerNotLoggedIn__tag">{{ 'BANNER_ARTICLE_TAG_PRESSAGENCY' | translate }}</div>
                  <div class="bannerNotLoggedIn__tag">#news</div>
                  <div class="bannerNotLoggedIn__tag">#media</div>
                </div>
                <button class="bannerNotLoggedIn__button-submit btn btn-login">
                  {{ 'BANNER_ARTICLE_SUBSCRIBE' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div>
          <ul class="cat-tags" *ngIf="semantics && semantics.categories">
            <li title="{{ 'ARTICLE_CATEGORIES' | translate }}" *ngFor="let cat of semantics.categories" class="cat">
              <span>{{ cat.value }}</span>
            </li>
          </ul>
          <ul class="cat-tags" *ngIf="semantics && semantics.terms">
            <li
              title="{{ 'ARTICLE_TERMS' | translate }}"
              *ngFor="let term of semantics.terms"
              class="term"
              (click)="search(term.value)"
            >
              <span>#{{ term.value }}</span>
            </li>
          </ul>
        </div>
      </article>
    </div>
  </section>
  <section class="col-lg-4 more-like">
    <aside>
      <h2 *ngIf="(moreLikeArticles$ | async).length" class="d-flex justify-content-lg-end text-lg-right">
        {{ 'ARTICLE_ON_THE_SAME_SUBJECT' | translate }}
      </h2>
      <div class="content" *ngIf="isLoadingMoreLikeArticles$ | async">
        <app-ghosts-elements [nbElements]="nbElements"></app-ghosts-elements>
      </div>
      <ng-container *ngIf="(moreLikeArticles$ | async).length">
        <ul class="timeline">
          <li
            class="event more-like-item mb-4 d-flex flex-column"
            data-date="18h"
            *ngFor="let article of moreLikeArticles$ | async"
          >
            <span class="article-date"
              >{{ article?.publication_date | date: 'MMM d y H:mm' }}
              <app-main-category-btn
                (searchString$)="search($event)"
                mainCategory="{{ article?.mainCategory }}"
              ></app-main-category-btn>
            </span>
            <h3 (click)="showMltArticle(article)" [innerHTML]="article?.title"></h3>
            <span class="article-domain mb-auto">etx daily up</span>
          </li>
        </ul>
      </ng-container>
    </aside>
  </section>
</div>

<app-latest-articles
  (searchString$)="search($event)"
  *ngIf="isLoggedIn && article"
  (scrollToTop)="scrollToTop()"
  [article]="article"
></app-latest-articles>
